import { createAction } from "typesafe-actions"

import { LegendTypes } from "library/common/types/legend"

export const toggleLegend = createAction(LegendTypes.TOGGLE_LEGEND)()
